import React, { useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import themeLight from "../../components/shared/theme";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TransferDetailsComponent from "../transferDetails/TransferDetailsComponent";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
  AppBar,
  Toolbar,
  Grid,
  ButtonGroup,
  DialogActions,
  DialogContent,
  Dialog,
  Divider,
  Checkbox,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditPopUp from "../shared/EditPopUp";
import TransferActivity from "./Activity/TransferActivity";
import api from "../../store/api";
import DeletePopUp from "../shared/DeletePopUp";
import CloseIcon from "@material-ui/icons/Close";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { consts } from "../../common/consts";
import format from "date-fns/format";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { useState } from "react";
import {
  getOriginLocationString,
  getDestinationLocationString,
  getTimeFromDate,
  getTimeFromDatebyZone,
} from "../../common/helpers";

interface ITripEvent {
  tripEventId: string | undefined;
  status: number | undefined;
  statusName: string | undefined;
  createdOn: string | undefined;
}

interface IEditPopUpInfo {
  tripEvents: ITripEvent;
  distance: number | undefined;
  discount: number | undefined;
}

interface IParams {
  transferid: string | undefined;
  bookingid: string | undefined;
}

interface IAuditEntries {
  changedColumnCaptions: any;
  auditId: string;
  userId: string;
  type: string;
  tableName: string;
  dateTime: string;
  primaryKey: string;
  userName: string;
  eventDescription: string;
  changedColumns: string[];
  hasDetails: boolean;
  newFields: any;
  oldFields: any;
}

{
  /* Styles */
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(0),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    buttonRoot: {
      backgroundColor: "#F4B827",
      color: "#03090E",
      "&:hover": {
        backgroundColor: "#F4B827",
      },
      fontWeight: "bold",
    },
    container: {
      backgroundSize: "100%",
      borderRadius: "0",
      width: "100%",
    },
    button: {
      width: "100%",
    },
    loading: {
      width: "100%",
    },
    yellowBoxText: {
      background: "#0049a3",
      padding: "6px 16px",
      fontSize: 14,
      fontWeight: 700,
      color: "#FFF",
      borderRadius: 4,
      cursor: "pointer",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "center",
    },
    switchButton: {
      textTransform: "none",
      width: 100,
      height: 28,
      fontWeight: 400,
      fontSize: 14,
      borderColor: "#0049a3",
    },
  })
);

const YellowBox = ({
  title,
  childComp = null,
  onClick = null,
  ...rest
}: any) => {
  const classes = useStyles();
  if (!title) return null;
  return (
    <span onClick={onClick} className={classes.yellowBoxText} {...rest}>
      {childComp || title}
    </span>
  );
};

const useMiddleDetailStyle = makeStyles((theme: Theme) =>
  createStyles({
    vehInfo: {
      fontSize: 24,
      fontWeight: 600,
      color: "#333333",
    },
    colTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: "#333333",
      marginTop: 22,
    },
    colInfo: {
      fontSize: 18,
      color: "#333333",
    },
    otherTransfer: {
      fontSize: 18,
      color: "#02489D",
    },
    buttelPoint: {
      fontSize: 16,
      fontWeight: 400,
      padding: 1,
    },
  })
);

const useStylesdownloadPdf = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      marginLeft: 20,
      fontWeight: "bold",
    },
    dialogText: {
      fontSize: 20,
      fontWeight: "bold",
      color: "#333333",
      marginTop: 10,
      marginBottom: 0,
    },
    dialogMsg: {
      fontSize: 20,
      opacitiy: 0.5,
      marginTop: 5,
      fontWeight: 400,
      color: "#333333",
      textAlign: "justify",
    },
    textContainer: {
      display: "flex",
      alignItems: "flex-start",
    },
    dialogTitleContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    closeBtn: {
      marginRight: 15,
    },
  })
);

const DownloadPopUp = ({
  isDialogOpen = false,
  onClick,
  transferId,
  downloadPdf,
  childComp,
  setIncludeRevision,
}: any) => {
  const classes = useStylesdownloadPdf();
  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => onClick(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth="sm"
    >
      <div className={classes.dialogTitleContainer}>
        <h2 className={classes.dialogTitle}>Download PDF</h2>
        <IconButton className={classes.closeBtn} onClick={() => onClick(false)}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent>
        <div className={classes.textContainer}>
          <div>
            <Checkbox
              name="includeRevision"
              color="primary"
              onChange={(e) => setIncludeRevision(e.target.checked)}
            />
          </div>
          <div>
            <h3 className={classes.dialogText}>Include revision history</h3>
            <p className={classes.dialogMsg}>
              Revision history will show how the transfer looked after each
              change was made to it. Note: This can add a large number of pages
              to your pdf
            </p>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: "space-between" }}>
        <Button
          onClick={() => onClick(false)}
          style={{ backgroundColor: "#ececec" }}
        >
          Cancel
        </Button>
        <Button color="primary" onClick={() => downloadPdf({ transferId })}>
          {childComp || "Download"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ButtletPoint = ({ style, item }: { style?: any; item?: any }) => {
  const classes = useMiddleDetailStyle();
  return (
    <Typography className={classes.buttelPoint} style={style}>
      <FiberManualRecordIcon style={{ fontSize: 10, marginRight: 5 }} />
      {item.createdOn &&
        getTimeFromDatebyZone(
          item.createdOn,
          item.customerLocationtimezone
        )}{" "}
      {item?.statusName}
    </Typography>
  );
};
const capitalizeFirstLetter = (string: any) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const ButtletPointPrice = ({ item, style }: { style?: any; item?: any }) => {
  const classes = useMiddleDetailStyle();
  let price =  JSON.stringify(item[1])
  return (
    <Typography className={classes.buttelPoint} style={style}>
      <FiberManualRecordIcon style={{ fontSize: 10, marginRight: 5 }} />
      {capitalizeFirstLetter(item[0])}
      {price && (
        <span style={{ float: "right" }}>
          {price != "null" && price != "{}"
            ? "$" + naiveRound(Number(price), 2)
            : ""}
        </span>
      )}
    </Typography>
  );
};

const getTripDurationString = (estimatedEvents: any) => {
  const tripDuration = estimatedEvents.reduce((a: any, b: any) => {
    return { ...a, duration: a.duration + b.duration };
  }).duration;
  const hours = Math.floor(tripDuration / 60);
  const minutes = tripDuration % 60;
  return `${
    hours <= 0 ? "" : `${hours} hour${hours > 1 ? "s" : ""}`
  } ${minutes} minute${minutes > 1 ? "s" : ""}`;
};
function naiveRound(num: number, decimalPlaces = 0) {
  var p = Math.pow(10, decimalPlaces);
  return Math.round(num * p) / p;
}

const ReasonForDelayModel = ({ classes, transferData, reasonForDelay }: { classes?: any; transferData?: any; reasonForDelay?:any }) => {
  return (
    <>
      <div>
        <Typography className={classes.colTitle}>
          Reason For Delay
        </Typography>
        <Typography className={classes.colInfo}>
          {transferData.reasonForDelayId
            ? reasonForDelay?.find(
              (reason: any) =>
                reason.reasonForDelayId ===
                transferData.reasonForDelayId
            )?.name
            : "-"}
        </Typography>
      </div>
    </>
  );
};

const MiddleDetail = ({
  transferData,
  estimatedEvents,
  tripEvents,
  reasonForDelay,
  info,
  state,
  isAdmin,
  subtotals,
  roles,
}: any) => {
  const classes = useMiddleDetailStyle();
  return (
    <div style={{ margin: 0, padding: "0px 60px" }}>
      <div style={{ marginTop: 22 }}>
        <Typography className={classes.vehInfo}>
          Vehicle {transferData.assignedVehicle}
        </Typography>
        <Typography className={classes.vehInfo}>
          Driver {transferData.driverName}
        </Typography>
      </div>
      <div>
        <Grid container alignContent="flex-start">
          <Grid item md={3}>
            <div>
              <div>
                <Typography className={classes.colTitle}>Status</Typography>
                <Typography className={classes.colInfo}>
                  {info.status ? consts.TransferStatusIndex[info.status] : "-"}
                  {/* {"-"} */}
                </Typography>
              </div>
              <div>
                <Typography className={classes.colTitle}>
                  Other Transfer In Trip
                </Typography>
                <Typography className={classes.otherTransfer}>
                  {transferData?.otherPatientTransfers?.length !== 0
                    ? transferData.otherPatientTransfers?.map(
                        (patient: any) =>
                          ` ${patient.firstName} ${patient.lastName} `
                      )
                    : "-"}
                </Typography>
              </div>
              {isAdmin && estimatedEvents.length > 0 && (
                <div>
                  <Typography className={classes.colTitle}>
                    Estimated Duration
                  </Typography>
                  <Typography
                    className={classes.colInfo}
                    style={{ marginBottom: 8 }}
                  >
                    {getTripDurationString(estimatedEvents)}
                  </Typography>
                  {tripEvents.map((item: any) => {
                    return <ButtletPoint key={item} item={item} />;
                  })}
                </div>
              )}
            </div>
          </Grid>
          <Grid item md={3}>
            <div>
              <div>
                <Typography className={classes.colTitle}>
                  Scheduled Pickup Time
                </Typography>
                <Typography className={classes.colInfo}>
                  {transferData.scheduledDate &&
                    format(new Date(transferData.scheduledDate), "HH:mm")}
                </Typography>
              </div>
              <div>
                {/* <Typography className={classes.colTitle}>
                    Duration(estimated)
                  </Typography>
                  <Typography className={classes.colInfo}>
                    31 minutes
                  </Typography> */}
                <Typography className={classes.colTitle}>Discount</Typography>
                <Typography className={classes.colInfo}>{`${
                  info.discount ? info.discount + "%" : "-"
                }`}</Typography>
              </div>
              {isAdmin && transferData.billingCharge !== null && (
                <div>
                  <Typography className={classes.colTitle}>Price</Typography>
                  <Typography
                    className={classes.colInfo}
                    style={{ marginBottom: 8 }}
                  >
                    {"$" + naiveRound(transferData.billingCharge, 2)}
                  </Typography>
                  {subtotals !== undefined &&
                    subtotals.map((item: any) => {
                      let price = JSON.stringify(item[1]);
                      if (
                        price !== "null" &&
                        price !== "{}" &&
                        Number(price) !== 0
                      ) {
                        return (
                          <ButtletPointPrice
                            key={item}
                            item={item}
                            style={{ width: "280px" }}
                          />
                        );
                      }
                    })}
                </div>
              )}
            </div>
          </Grid>
          <Grid item md={3}>
            <div>
              <div>
                <Typography className={classes.colTitle}>
                  Trip Distance(optimal)
                </Typography>
                <Typography
                  className={classes.colInfo}
                >{`${info.distance} km`}</Typography>
              </div>
              {isAdmin ? (<div>
                <Typography className={classes.colTitle}>
                  Discount Price
                </Typography>
                <Typography className={classes.colInfo}>
                  {`${
                    info.discount && transferData.billingCharge
                      ? "$" +
                        naiveRound(
                          (naiveRound(transferData.billingCharge, 2) *
                            info.discount) /
                            100,
                          2
                        )
                      : "-"
                  }`}
                </Typography>
              </div>)
            :  
            <ReasonForDelayModel classes={classes} transferData={transferData} reasonForDelay={reasonForDelay} />
            }
            </div>
          </Grid>
          <Grid item md={3}>
            <div>
              <div>
                <Typography className={classes.colTitle}>
                  Duration(actual)
                </Typography>
                <Typography className={classes.colInfo}>
                  {state?.duration} min
                </Typography>
              </div>
              {isAdmin && (
                <ReasonForDelayModel classes={classes} transferData={transferData} reasonForDelay={reasonForDelay} />
              )}
              <div></div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

{
  /* Body */
}
interface IUserData {
  givenName: string;
  surName: string;
  email: string;
  role: string;
  IsAdmin: boolean;
  exp: number;
  location: string;
  ward: string;
  IsCustomer?: boolean | null | undefined,
  IsSMAUser?: boolean | null | undefined,
}

interface IAuthState {
  isAuthenticated?: boolean;
  token: string | null;
  userName: string | null;
  data: IUserData | null;
  sessionExpired: boolean;
  vehicleSessionId: string | null;
  vehicleNumber: string | null;
}

interface IRoles {
  IsAdmin: boolean;
  SMADriver: boolean;
  CustomerDriver: boolean;
  IsNotSMAUser: boolean;
  IsCustomer:boolean;
  IsSMA:boolean;
}

const getRoles = (authStore: IAuthState): IRoles => {
  return {
    IsAdmin: authStore?.data?.IsAdmin || false,
    SMADriver: authStore?.data
      ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 && authStore?.vehicleNumber
        ? true
        : false
      : false,
    CustomerDriver: authStore?.data
      ? authStore?.data?.role?.indexOf(consts.Permissions.CustomerDriver) >= 0 && authStore?.vehicleNumber
        ? true
        : false
      : false,
    IsNotSMAUser: authStore.data?.location !== undefined && authStore.data?.location !== null && authStore.data?.location !== "",
    IsCustomer:authStore?.data?.IsCustomer ||false,
    IsSMA:authStore?.data?.IsSMAUser ||false
  };
};

const TransferFullDetailsWidget = ({
  transferData,
  estimatedEvents,
  tripEvents,
  reasonForDelay,
  setPage, pageNumber
}: any) => {
  const classes = useStyles();
  const [editPopUpInfo, setEditPopUPInfo] = React.useState<IEditPopUpInfo[]>(
    []
  );
  const { authStore } = useSelector((state: RootState) => state);
  const [distance, setDistance] = React.useState("0");
  const [discount, setDiscount] = React.useState("0");
  const [reasonForDelayId, setReasonForDelayId] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [editPopUp, setEditPopUp] = React.useState(false);
  const [downloadingPDF, setDownloadingPDF] = React.useState(false);
  const [switchButton, setSwitchButton] = React.useState("details");
  const { transferid, bookingid } = useParams<IParams>();
  const history = useHistory();
  const [isDeleteDialogOpen, setDeleteDialogOpen] =
    React.useState<boolean>(false);
  const [downloadPdf, setDownloadPdf] = React.useState<boolean>(false);
  const tripEventsState = React.useState([]);
  const [includeRevision, setIncludeRevision] = React.useState(false);
  const [auditEntries, setAuditEntries] = React.useState<IAuditEntries[]>([]);
  const [loading, setLoading] = React.useState(false);
  const { state } = useLocation();
  const [subtotals, setsubtotals] = useState([]);
  const [roles, setRoles] = useState<IRoles>(getRoles(authStore));


  React.useEffect(() => {
    let billingSubTotals: any = [];
    if (transferData.billingSubTotals !== undefined) {
      const jsonObject = JSON.parse(transferData.billingSubTotals);
      if (jsonObject != undefined) {
        // Convert object to array of key-value pairs
        const keyValuePairs = Object.entries(jsonObject);
        billingSubTotals.push(keyValuePairs);
      }
    }
    setsubtotals(billingSubTotals);
  }, [transferData]);
  const getEditPopUpRecord = async ({ transferId,isAuditMenu }: { transferId: string | undefined,isAuditMenu: boolean | false }) => {
    setLoading(true);
    await api.getTransferEditDetailSMA(`transferId=${transferId}&isAuditMenu=${isAuditMenu}`).then((res: any) => {
        setLoading(false);           
        if(!res?.hasError)
          {
            if(isAuditMenu){
              setAuditEntries(res?.model?.auditEntries);
            }
            else{
              setEditPopUPInfo(res?.model);
              setDistance(res?.model?.distance);
              setDiscount(res?.model?.discount);
              setReasonForDelayId(res?.model?.reasonForDelayId);
              setStatus(res?.model?.status);
              const statusMap: any = { 7: true, 8: true, 9: true, 4: true };
              tripEventsState[1](res?.model?.tripEvents?.filter((item: any) => statusMap[item.status] === true));
            }
             
          }
     
    }).catch((err) => {
        setLoading(false);
        console.log(err);
    })
};

  const deleteTransfer = ({
    transferId,
  }: {
    transferId: string | undefined;
  }) => {
    api
      .deleteTransferSMA(`transferId=${transferId}`)
      .then((res) => {
        if (res.data.hasError == false) {
          // console.log(res.data.message);
          history.replace("/transfers/0");
        } else {
          console.log(res);
        }
      })
      .catch((err) => {
        alert(err.toString());
      });
  };

  const downloadTransfer = ({
    transferId,
  }: {
    transferId: string | undefined;
  }) => {
    setDownloadingPDF(true);
    api
      .exportTransferToPdf(
        `transferId=${transferId}&showRevisionHistory=${includeRevision}`,
        null
      )
      .then((res) => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${res}`;
        link.download = `${transferId}`;
        link.click();
      })
      .catch((err) => {
        alert(err.toString());
      })
      .finally(() => {
        setDownloadingPDF(false);
        setDownloadPdf(false);
      });
  };

  const deleteRecord = () => (
    deleteTransfer({ transferId: transferid }), setDeleteDialogOpen(false)
  );

    const closeEditPopUp = () => {
        setEditPopUp(false);
        getEditPopUpRecord({ transferId: transferid,isAuditMenu:false });
    };       

  function SubHeader() {
    const history = useHistory();
    return (
      <Grid container style={{ padding: 10 }}>
        <Grid xs={6} item>
          <Button
            style={{
              height: "100%",
              color: "#0049a3",
              display: "flex",
              justifyContent: "flex-start",
              paddingLeft: 20,
              fontSize: 18,
            }}
            onClick={() => {
              setPage(pageNumber);
              history.push(`/transfers/${pageNumber}`)
          }}
            startIcon={
              <ArrowBackIcon style={{ color: "#0049a3", fontSize: 18 }} />
            }
          >
            Back
          </Button>
        </Grid>
        <Grid xs={6} container alignContent="center" justify="flex-end">
          {authStore?.data?.IsAdmin && (
            <>
              {" "}
              <YellowBox
                title="Download"
                onClick={() => setDownloadPdf(true)}
                style={{ marginRight: 10, minWidth: 64 }}
              />
              <YellowBox
                title="Delete"
                onClick={() => setDeleteDialogOpen(true)}
                style={{ marginRight: 10 }}
              />
              <YellowBox
                title="Edit"
                onClick={() => setEditPopUp(true)}
                style={{ marginRight: 10 }}
              />{" "}
            </>
          )}
        </Grid>
        <Grid xs={12} item>
          <div
            style={{
              height: "100%",
              fontSize: 46,
              fontWeight: 700,
              color: "#333",
              marginLeft: 20,
              marginTop: 10,
            }}
          >
            Transfer {transferData?.bookingNumber}
          </div>
        </Grid>
      </Grid>
    );
  }

  const LoadingDiv = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center", padding: 20, fontSize: 18, fontWeight: 500 }}>Loading . . .</div>
        <LinearProgress />
      </>
    );
  };  

    const HorizontalLine = (props: any) => {
        return (
            <hr
                style={{
                    height: 0,
                    padding: 0,
                    borderTop: '1px solid #979797',
                    ...props
                }}
            />
        )
    }

    React.useEffect(() => {
        getEditPopUpRecord({ transferId: transferid,isAuditMenu:false });
    }, [])

    const onTabChange = (value: any) => {
      setSwitchButton(value);
      getEditPopUpRecord({ transferId: transferid,isAuditMenu:true });
    }

    return (
        <MuiThemeProvider theme={themeLight} >
            <Paper className={classes.container}>
                <SubHeader />
                <HorizontalLine />
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonGroup>
                        <Button
                            onClick={() => onTabChange("details")}
                            className={classes.switchButton}
                            style={{
                                borderTopLeftRadius: 15,
                                borderBottomLeftRadius: 15,
                                backgroundColor: switchButton == "details" ? "#0049a3" : "#FFF",
                                color: switchButton == "details" ? "#FFF" : "#0049a3",
                            }}
                        >
                            Details
                        </Button>
                        <Button
                            onClick={() => onTabChange("activity")}
                            className={classes.switchButton}
                            style={{
                                borderTopRightRadius: 15,
                                borderBottomRightRadius: 15,
                                backgroundColor: switchButton == "activity" ? "#0049a3" : "#FFF",
                                color: switchButton == "activity" ? "#FFF" : "#0049a3",
                            }}
                        >
                            Activity
                        </Button>
                    </ButtonGroup>
                </div>

                <div style={switchButton === "details" ? {} : { display: "none" }}>
                  {!loading ? (
                    <div>
                            <MiddleDetail isAdmin={authStore?.data?.IsAdmin} transferData={transferData} estimatedEvents={estimatedEvents} tripEvents={tripEvents} reasonForDelay={reasonForDelay} info={editPopUpInfo} state={state} subtotals={subtotals[0]} roles={roles} />
                      <HorizontalLine borderColor="#9797973B" marginTop="52px" />
                      <div style={{ padding: 60 }}>
                        {transferData ? <TransferDetailsComponent data={transferData} theme="light" /> : null}
                      </div>
                    </div>
                  ) : (
                    <LoadingDiv />
                  )}

                </div>
                <TransferActivity style={switchButton == "activity" ? {} : { display: "none" }} auditEntries={auditEntries} loading={loading} />
                
            </Paper>
            <EditPopUp popState={editPopUp} onClose={closeEditPopUp} transferInfo={editPopUpInfo} tripEventsState={tripEventsState} reasonForDelay={reasonForDelay} discount={discount} distance={distance} reasonForDelayId={reasonForDelayId} status={status} setDiscount={setDiscount} setDistance={setDistance} setReasonForDelayId={setReasonForDelayId} setStatus={setStatus} />
            <DeletePopUp 
                isDialogOpen={isDeleteDialogOpen} 
                onCancel={() => setDeleteDialogOpen(false)} 
                onDo={deleteRecord} 
                title="Delete transfer"
                recordName="transfer" 
            />
            <DownloadPopUp childComp={downloadingPDF ? < CircularProgress style={{ color: "white", width: 30, height: 30 }} /> : null} isDialogOpen={downloadPdf} onClick={setDownloadPdf} transferId={transferid} downloadPdf={downloadTransfer} setIncludeRevision={setIncludeRevision} />
        </MuiThemeProvider >
    );
}

export default TransferFullDetailsWidget;
